module.exports = __webpack_public_path__ + "0b9e1bfb17b787655d93ac4fca203995.svg";


//////////////////
// WEBPACK FOOTER
// ./images/space_legal.svg
// module id = ./images/space_legal.svg
// module chunks = 5